import { folderSchemas } from "@redotech/redo-model/views/folders";
import { viewWithIdSchemas } from "@redotech/redo-model/views/views";
import { ReturnTypeEnum } from "@redotech/redo-return-core-common/return-type-enum";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";
import { null as zNull } from "zod";
export const saveReturnViewsAndFolders = {
  name: "saveReturnViewsAndFolders" as const,
  input: z.object({
    folders: z.array(folderSchemas.returns),
    views: z.array(viewWithIdSchemas.returns),
    type: createEnum(ReturnTypeEnum),
  }),
  output: zNull(),
};
